const LABLES = {
    Email: "Email",
    Name: "Name",
    NewPassword: "New Password",
    ConfirmPassword: 'Confirm password',
    PlantName: "Plant Name",
    PlantId: "Plant Id",
    PlantCode: 'Plant Code',
    Designation: "Designation",
    ForgotPassword: "Forgot Password",
    RequestAccess: "Request Access",
    CurrentPassword: "Current Password",
    Dashboard: "Dashboard",
    MyTask: "My Task",
    DraftAudits: "Draft Audits",
    InProgressAudits: "In Progress Audits",
    InProgressAudit: "In Progress Audit",
    CompletedAudits: "Completed Audits",
    Apply: "Apply",
    Facility: "Facility (Plant)",
    CreateAudit: "Create Audit",
    AuditBeginDate: "Audit Begin Date",
    PlantDirector: "Plant Director",
    AuditEndDate: "Audit End Date",
    AuditName: "Audit Name",
    LastAuditedDate: "Last Audited Date",
    LastAuditUpdated: "Last Audit Updated",
    /* audit details table heads */
    Filters: "Filters",
    FilterByPlant: 'Filter By Plant',
    FilterByDate: 'Filter By Date',
    Password: "Password",
    Plant: "Plant",
    Auditor: "Auditor",
    Reviewer: "Reviewer",
    AssetType: "Asset Type",
    Line: "Line",
    Asset: "Asset",
    Type: "Type",
    Frequency: "Frequency",
    PMScript: "PM Script",
    StartDate: "Start Date",
    EndDate: "End Date",
    EstimateDate: "Estimate Date",
    Status: "Status",
    Action: "Action",
    /* end audit details table heads */
    AddTask: "Add Task",
    GenerateReport: "Generate Report",
    SaveasDraft: "Save as Draft",
    Submit: "Submit",
    ViewAudit: "View Audit",
    ViewTask: "View Task",
    Reassign: "Reassign",
    CompletedTask: "Completed",
    ChangePassword: "Change Password",
    LogOut: "Log Out",
    SortBy: 'Sort By',
    OrgCode: "Org Code",
    AuditType: 'Audit Type',
    Area: 'Area',
    Activity: 'Activity',
    UserManagement: 'User Management',
    QuestionManagement: 'Question Management',
    PlantManagement: 'Plant Management',
    PlantList: 'Plant List',
    PlantType: 'Plant Type',
    VLM: 'VLM',
    NonVLM: 'Non-VLM',
    DirectorName: 'Director Name',
    UpdatePlant: 'Update Plant',
    ADDPLANT: 'Add Plant',
    UpdateWeightage: 'Update Weightage',
    TotalWeightage: 'Total Weightage',
    Oval: 'Oval',
    PreventativeMaintenance: 'Preventative Maintenance',
    SNo: 'Sno.',
    StaticQues: 'Static Questions',
    CreateUser: 'Create User',
    FirstName: 'First Name',
    LastName: 'Last Name',
    Role: 'Role',
    Active: 'Active',
    InActive: 'In-Active',
    EmailAddress: 'Email Address',
    POST: 'POST',
    GET: 'GET',
    PUT: 'PUT',
    PDFUpload: 'PDF Upload',
    ExcelUpload: 'Excel Upload',
    UploadFAQ: 'Upload FAQ',
    BulkUpload: 'Bulk Upload',
    BulkUserUpload: 'Bulk User Upload',
    UploadUserData: 'Upload User Data',
    ScoringManagement: 'Scoring Management'
};

const BUTTONS = {
    Login: "Login",
    Submit: "Submit",
    OK: "OK",
    Cancel: "Cancel",
};

const STRINGS = {
    GoBackToLogin: "Go back to login",
    ThankYou: 'Thank you',
    ProblemSigningIn: 'Problem Signing In?',
    FIELDREQUIRED: 'This field is required.',
    FIRSTNAMEREQUIRED: 'First Name is required.',
    LASTNAMEREQUIRED: 'Last Name is required.',
    PLEASESELECTROLE: 'Please select your role.',
    CORRECTEMAIL: 'Please enter correct email ID.',
    CORRECTPASSWORD: 'Please enter correct password.',
    PLEASEUPLOADPDF: 'Please upload the PDF file.',
    PLEASEUPLOADEXCEL: 'Please upload the excel file.',
    SelectLine: 'Please select line',
    SelectAsset: 'Please select asset',
    SelectType: 'Please select type',
    PLANTREQUIRED: 'Plant is required.',
    PLANTNAMEREQUIRED: 'Plant name is required.',
    ARMAPLANTIDREQUIRED: 'Plant id is required.',
    PLANTCODEREQUIRED: 'Plant code is required.',
    ORGCODEREQUIRED: 'Org Code is required.',
    PLANTDIRECTORREQUIRED: 'Plant director is required.',
    PLANTTYPEREQUIRED: 'Plant type is required.',
    FetchPlant: 'Fetching plants data',
    SelectPlant: 'Please select plant',
    UpdatePlantDetails: 'Updating plant details',
    SelectPlantUpdate: 'Please select plant in order to update',
    UpdatePlantSuccess: 'Plant details updated successfully',
    ConfirmCredentials: 'Confirming login credentials',
    FetchSubQues: 'Fetching static questions',
    OperationAlertMsg: 'Please complete currently running operation first',
    UpdateStaticQues: 'Updating static question',
    ListStaticQues: 'List of Static Questions',
    SelectQuesType: 'Please select question type',
    FetchUserData: 'Fetching users data',
    ListUsers: 'List of Niagara ARMA Users',
    SelectRole: 'Please select role',
    UpdateUserDetails: 'Updating user details',
    CreateNewUser: 'Creating new user',
    AllUserFields: 'All fields are required in order to update user data',
    AllFieldRequired: 'All fields are required',
    UPLOADFAQ: 'Upload FAQ',
    FAQLOADERMSG: "Uploading FAQ",
    BULKUPLOADLOADERMSG: 'Uploading User Data',
    SECTIONALSCORING: 'Section Scoring',
    SELECTAUDITTYPE: 'Select Audit Type',
    SCOREERROR: 'Total weightage is not equal to 100',
    PlantManagement: 'Plant Management',
    ADDNEWPLANT: 'Adding new plant'
};

const REGEX = {
    EMAIL: (/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i)
}

const SELECT_DEFAULT_VALUE = { id: 'default', value: '', content: 'Please Select' };
const TAB_TYPES = {
    'Draft': 1,
    'My_Task': 2,
    'In_Progress': 3,
    'Completed': 4
};
const AUDIT_STATUS = {
    'IN_DRAFT': 0,
    'IN_PROGRESS': 1,
    'COMPLETED': 2
};
const USER_ROLES = {
    AuditManager: 'audit manager',
    Reviewer: 'reviewer',
    Auditor: 'auditor',
    PlantManager: 'plant manager',
    PlantAuditor: 'plant auditor',
    PlantReviewer: 'plant reviewer'
};

export {
    SELECT_DEFAULT_VALUE,
    LABLES,
    BUTTONS,
    STRINGS,
    REGEX,
    TAB_TYPES,
    AUDIT_STATUS,
    USER_ROLES
};